import React from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Typography
} from '@material-ui/core';

import ActivityContent from './ActivityContent';

const styles = makeStyles(theme => ({
	tipRoot: {
		marginTop: theme.spacing(2)
	}
}));

function TipInfo(props) {
	let classes = styles(),
		{concernOtherDescription, history} = props;

	return (
		<div className={classes.tipRoot}>
			<Typography variant="caption">Concern for Someone Else</Typography>
			<ActivityContent content={concernOtherDescription} history={history} />
		</div>
	);
}

TipInfo.propTypes = {
	concernOtherDescription: PropTypes.string.isRequired,
	history: PropTypes.object.isRequired
};

export default TipInfo;
